/** "1 seat", "2 seats" — the count with its noun in the right number
 *  (Employee R2, E2E observation 8: the floor plan said "1 seats"). */
export function countOf(n: number, one: string, many = `${one}s`): string {
  return `${n} ${n === 1 ? one : many}`;
}
